export default __webpack_public_path__ + "static/media/playngo.dd2364e9.png";